import App from './App'
import { initializeApp } from 'firebase/app'
import { getFirestore, connectFirestoreEmulator } from 'firebase/firestore'
import { getStorage, connectStorageEmulator } from 'firebase/storage'

const options = {
  apiKey: 'AIzaSyDNJrKrAWC5UROzMHQJmdrj_L-1ZkUzqGI',
  authDomain: 'inspire-health-tech-admin.firebaseapp.com',
  databaseURL: 'https://inspire-health-tech-admin-default-rtdb.firebaseio.com',
  projectId: 'inspire-health-tech-admin',
  storageBucket: 'inspire-health-tech-admin.firebasestorage.app',
  messagingSenderId: '408062992856',
  appId: '1:408062992856:web:d9e49d2cd643e5607bd2ad'
}

const uatOptions = {
  apiKey: 'AIzaSyClfRwq0QmFxhMeedHqWGfnuTqtRzTHF3w',
  authDomain: 'uat-iht-self-service.firebaseapp.com',
  projectId: 'uat-iht-self-service',
  storageBucket: 'uat-iht-self-service.firebasestorage.app',
  messagingSenderId: '87850684879',
  appId: '1:87850684879:web:fd04bb831fa7ca51fc42ba',
  measurementId: 'G-9QDBG4HG8X'
}

const isUat = window.location.hostname === 'localhost' || window.location.hostname === 'uat-iht-self-service.web.app'

// Initialize Firebase synchronously at module load
const app = initializeApp(isUat ? uatOptions : options)

const db = getFirestore(app)
const storage = getStorage(app)

if (import.meta.env.VITE_APP_EMULATORS === 'true') {
  connectFirestoreEmulator(db, 'localhost', 8080)
  connectStorageEmulator(storage, 'localhost', 9199)
}

function FirebaseInit () {
  return <App />
}

export default FirebaseInit

export { db, storage }
